var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-item',{attrs:{"tag":"label"}},[_c('q-item-section',[_c('q-item-label',[_vm._v("Use PWA")])],1),_c('q-item-section',{attrs:{"avatar":""}},[_c('q-toggle',{model:{value:(_vm.use_pwa),callback:function ($$v) {_vm.use_pwa=$$v},expression:"use_pwa"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }